import { Link } from "react-router-dom";
import { comparisonData } from "@/mocks/homeData";

export default function CTASection() {
  return (
    <section className="py-14 md:py-20 px-4 md:px-8 lg:px-16 bg-background-100">
      <div className="max-w-3xl mx-auto text-center">
        <h2 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-foreground-950">
          Prêt à remplacer Excel ?
        </h2>
        <p className="mt-4 text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
          Découvrez pourquoi les vendeurs choisissent <strong>hipobuy spreadsheet</strong>
        </p>

        <a
          href="https://kaspreadsheet.com/"
          target="_blank"
          rel="noopener nofollow"
          className="inline-flex items-center gap-2 mt-8 px-8 py-4 bg-accent-500 text-background-50 dark:text-foreground-950 rounded-full text-sm font-semibold uppercase tracking-wider whitespace-nowrap hover:bg-accent-600 transition-colors cursor-pointer"
        >
          Accéder à la Plateforme
          <i className="ri-arrow-right-line text-sm"></i>
        </a>

        <div className="mt-12 overflow-x-auto">
          <table className="w-full text-left border-collapse">
            <thead>
              <tr className="border-b border-foreground-200">
                <th className="py-3 px-4 text-xs font-semibold text-foreground-500 uppercase tracking-wider whitespace-nowrap">Fonction</th>
                <th className="py-3 px-4 text-xs font-semibold text-foreground-500 uppercase tracking-wider whitespace-nowrap">Excel classique</th>
                <th className="py-3 px-4 text-xs font-semibold text-foreground-500 uppercase tracking-wider whitespace-nowrap">Hipobuy Spreadsheet</th>
              </tr>
            </thead>
            <tbody>
              {comparisonData.map((row) => (
                <tr key={row.feature} className="border-b border-background-200">
                  <td className="py-3.5 px-4 text-sm font-medium text-foreground-800 whitespace-nowrap">{row.feature}</td>
                  <td className="py-3.5 px-4 text-sm text-foreground-600 whitespace-nowrap">{row.excel}</td>
                  <td className="py-3.5 px-4 text-sm font-medium text-primary-700 whitespace-nowrap">{row.hipobuy}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mt-10">
          <p className="text-sm text-foreground-500 mb-4">
            Avec le <strong>hipobuy spreadsheet</strong>, les vendeurs peuvent :
          </p>
          <div className="flex flex-wrap justify-center gap-3 text-xs text-foreground-600">
            <span className="px-3 py-1.5 bg-background-200 rounded-full whitespace-nowrap">Réduire le temps d'analyse de 60%</span>
            <span className="px-3 py-1.5 bg-background-200 rounded-full whitespace-nowrap">Améliorer la prise de décision</span>
            <span className="px-3 py-1.5 bg-background-200 rounded-full whitespace-nowrap">Identifier les produits rentables</span>
            <span className="px-3 py-1.5 bg-background-200 rounded-full whitespace-nowrap">Scalabilité e-commerce</span>
          </div>
        </div>

        <div className="mt-10">
          <Link
            to="/guide-hipobuy-spreadsheet"
            className="inline-flex items-center gap-2 px-8 py-4 bg-foreground-950 text-background-50 rounded-md text-sm font-semibold uppercase tracking-wider whitespace-nowrap hover:bg-foreground-800 transition-colors cursor-pointer group"
          >
            Lire le guide complet
            <i className="ri-arrow-right-line text-sm group-hover:translate-x-0.5 transition-transform"></i>
          </Link>
        </div>
      </div>

      <div className="mt-16 flex items-center justify-center gap-8 md:gap-12 flex-wrap opacity-50">
        <img src="https://readdy.ai/api/search-image?query=Minimal%20running%20shoe%20isolated%20on%20warm%20off-white%20background%2C%20clean%20product%20cutout%2C%20soft%20studio%20lighting%2C%20athletic%20lifestyle%20aesthetic&width=120&height=120&seq=cta-product-v3-1&orientation=squarish" alt="Shoes" title="Produit Shoes" className="w-16 h-16 md:w-20 md:h-20 object-contain" loading="lazy" />
        <img src="https://readdy.ai/api/search-image?query=Chunky%20knit%20cardigan%20isolated%20on%20warm%20off-white%20background%2C%20clean%20product%20cutout%2C%20soft%20studio%20lighting%2C%20cozy%20Scandinavian%20style&width=120&height=120&seq=cta-product-v3-2&orientation=squarish" alt="Hoodie" title="Produit Hoodie" className="w-16 h-16 md:w-20 md:h-20 object-contain" loading="lazy" />
        <img src="https://readdy.ai/api/search-image?query=Striped%20cotton%20shirt%20isolated%20on%20warm%20off-white%20background%2C%20clean%20product%20cutout%2C%20soft%20studio%20lighting%2C%20casual%20French%20style&width=120&height=120&seq=cta-product-v3-3&orientation=squarish" alt="T-Shirt" title="Produit T-Shirt" className="w-16 h-16 md:w-20 md:h-20 object-contain" loading="lazy" />
        <img src="https://readdy.ai/api/search-image?query=Suede%20bomber%20jacket%20isolated%20on%20warm%20off-white%20background%2C%20clean%20product%20cutout%2C%20soft%20studio%20lighting%2C%20modern%20urban%20style&width=120&height=120&seq=cta-product-v3-4&orientation=squarish" alt="Jacket" title="Produit Jacket" className="w-16 h-16 md:w-20 md:h-20 object-contain" loading="lazy" />
        <img src="https://readdy.ai/api/search-image?query=Cotton%20tote%20bag%20isolated%20on%20warm%20off-white%20background%2C%20clean%20product%20cutout%2C%20soft%20studio%20lighting%2C%20eco-friendly%20minimal%20style&width=120&height=120&seq=cta-product-v3-5&orientation=squarish" alt="Bag" title="Produit Bag" className="w-16 h-16 md:w-20 md:h-20 object-contain" loading="lazy" />
        <img src="https://readdy.ai/api/search-image?query=Canvas%20baseball%20cap%20isolated%20on%20warm%20off-white%20background%2C%20clean%20product%20cutout%2C%20soft%20studio%20lighting%2C%20casual%20street%20style&width=120&height=120&seq=cta-product-v3-6&orientation=squarish" alt="Cap" title="Produit Cap" className="w-16 h-16 md:w-20 md:h-20 object-contain" loading="lazy" />
      </div>
    </section>
  );
}